import {
  ExpressionEvaluator,
  ExpressionEvaluatorSanitiseKeyFn,
  ExpressionEvaluatorType
} from './interfaces/expression-evaluator';
import { PrimitiveTypes } from '../shared/interfaces/generics';

export class IdentifierExpression
  implements ExpressionEvaluator<Record<string, PrimitiveTypes>, PrimitiveTypes>
{
  identifier: string;

  constructor(identifier: string) {
    this.identifier = identifier;
  }

  getType() {
    return ExpressionEvaluatorType.IDENTIFIER;
  }

  evaluate(
    model: Record<string, PrimitiveTypes>,
    getSanitiseKey: ExpressionEvaluatorSanitiseKeyFn
  ) {
    const sanitisedKey = getSanitiseKey(this.identifier);
    return model[sanitisedKey];
  }
}
